import React from "react"
import { Link } from "../../../server/router"

const LoginActionButtons = () => {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                fontWeight: 400,
                fontSize: "1rem",
                lineHeight: "1.5",
                paddingTop: "1rem",
            }}
            className="login-action-bts">
            <Link href="/reset-password-request">Forgot Your Password?</Link>
            <Link href="/sign-up" id="sign_up">
                Sign Up
            </Link>
        </div>
    )
}

export default LoginActionButtons
